import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["children", "jss", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Section from "../Layout/Section";
import createStyles from "../createStyles";
var useStyles = createStyles(function (theme) {
  return {
    section: _defineProperty({
      color: theme.palette.text.secondary,
      padding: theme.spacer(6, 4)
    }, theme.breakpoints.create('sm'), {
      padding: theme.spacer(6, 8, 6, 6)
    })
  };
}, {
  name: 'DialogContent'
});

var DialogContent = function DialogContent(_ref) {
  var children = _ref.children,
      _ref$jss = _ref.jss,
      jss = _ref$jss === void 0 ? {} : _ref$jss,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    jss: jss
  });
  return /*#__PURE__*/React.createElement(Section, _extends({
    className: classNames(className, classes.section)
  }, props, {
    "data-qa": "dialog-content"
  }), children);
};

DialogContent.propTypes = {
  /** Child elements to render in header */
  children: PropTypes.node.isRequired,

  /** JSS override object */
  jss: PropTypes.oneOfType([PropTypes.shape(), PropTypes.func]),

  /** Additional classname to root component */
  className: PropTypes.string
};
export default DialogContent;